import { Injectable } from '@angular/core';
import { HttpClient, HttpHeaders } from '@angular/common/http';
import { UsuarioSesion } from '../models/usuario-sesion.interface';
import { Router } from '@angular/router';
const httpOptions = {
  headers: new HttpHeaders({
    'Content-Type': 'application/json',
    'Cache-Control': 'no-cache',
    'Pragma': 'no-cache'
  })
};
@Injectable({
  providedIn: 'root'
})
export class AuthService {
  private usuario: UsuarioSesion | null = null;


  constructor(private http: HttpClient, private router: Router) { }

  get isLoggedIn(): boolean {
    return localStorage.getItem('token') !== null;
  }

  get getLoggedIn(): boolean {
    return localStorage.getItem('usuario') !== null;
  }

  setUsuario(usuario: UsuarioSesion): void {
    usuario = { ...usuario, password: '', contrasenia: '' }; // Limpiar la contraseña antes de almacenar
    localStorage.setItem('usuario', JSON.stringify(usuario));
  }

  get getUsuario(): UsuarioSesion | null {
    let usuario = null;
    if (usuario = localStorage.getItem('usuario')) {
      usuario = JSON.parse(usuario);
    };
    return usuario;
  }

  setToken(token: string): void {
    localStorage.setItem('token', token);
  }
  get getToken(): string | null {
    return localStorage.getItem('token');
  }

  cerrar(): void {
    this.usuario = null;
    localStorage.removeItem("usuario");
    localStorage.removeItem("token");

    this.router.navigate(['']);
  }
}